import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=1b1c0da6&scoped=true&"
import script from "./Information.js?vue&type=script&lang=js&"
export * from "./Information.js?vue&type=script&lang=js&"
import style0 from "./information.scss?vue&type=style&index=0&id=1b1c0da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c0da6",
  null
  
)

export default component.exports